module.exports = __webpack_public_path__ + "img/9cc1a7d.jpg";